import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { installImageFallback } from './Helpers/imageFallback';
import { Provider } from 'react-redux';
import { store, persistor } from './Redux/Store';
import { PersistGate } from "redux-persist/integration/react";
import "react-range-slider-input/dist/style.css";

// Swaps any image that fails to load for a neutral "No image" placeholder.
installImageFallback();

// Global error handlers for chunk load failures outside React tree
const CHUNK_RELOAD_KEY = "chunk_reload_attempted";

function isChunkLoadError(error: any): boolean {
  if (!error) return false;
  const message = error?.message || "";
  return (
    error?.name === "ChunkLoadError" ||
    message.includes("Loading chunk") ||
    message.includes("Failed to fetch dynamically imported module")
  );
}

window.addEventListener("error", (event) => {
  if (isChunkLoadError(event.error)) {
    event.preventDefault();
    if (!sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
      sessionStorage.setItem(CHUNK_RELOAD_KEY, "true");
      window.location.reload();
    }
  }
});

window.addEventListener("unhandledrejection", (event) => {
  if (isChunkLoadError(event.reason)) {
    event.preventDefault();
    if (!sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
      sessionStorage.setItem(CHUNK_RELOAD_KEY, "true");
      window.location.reload();
    }
  }
});

// Clear reload flag on successful page load
if (sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
  sessionStorage.removeItem(CHUNK_RELOAD_KEY);
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
